import { Theme, makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const useStyles = makeStyles(
  ({ spacing }: Theme) => ({
    root: {
      color: SecondaryColors.main,
      marginRight: spacing(1.5),

      '&:last-child': {
        marginRight: spacing(0),
      },
    },
    link: {
      minWidth: 'auto !important',
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'LinkItem' },
);

export default useStyles;
